import { PLAN_CREATION_REASONS } from '../../../../../contexts/create-plan-context/create-plan-context-types/plan-create-reason';
import { DuplicatePlanSavingOption } from './types/duplicate-plan-saving-option';

export type OptionItem = {
  value: DuplicatePlanSavingOption;
  label: {
    title: string;
    subTitle: string;
  };
};

export const OPTION_ITEMS: OptionItem[] = [
  {
    value: PLAN_CREATION_REASONS.NewContract,
    label: {
      title: 'Start a new contract  ',
      subTitle: 'Build a dedicated pricing plan to your customer',
    },
  },
  {
    value: PLAN_CREATION_REASONS.NewPlan,
    label: {
      title: 'Save as a template',
      subTitle: 'Keep this as a reusable draft for future contracts',
    },
  },
];
